function safe(a) {
  return typeof a === 'undefined' ? 'undefined' : a
}

function safeReplace(a, search, replaceValue) {
  return safe(a).replace(search, replaceValue)
}

module.exports = function joinURL() {
  let url = arguments[0]
  for (let i = 1; i < arguments.length; ++i) {
    url = safeReplace(url, /\/$/, '') + '/' + safeReplace(arguments[i], /^\//, '') //eslint-disable-line prefer-template
  }
  return url
}



// WEBPACK FOOTER //
// ./node_modules/santa-main-r/src/lib/common/joinURL.js